import { render, staticRenderFns } from "./DocumentPageComponent.vue?vue&type=template&id=658546db&scoped=true"
import script from "./DocumentPageComponent.vue?vue&type=script&lang=js"
export * from "./DocumentPageComponent.vue?vue&type=script&lang=js"
import style0 from "./DocumentPageComponent.vue?vue&type=style&index=0&id=658546db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658546db",
  null
  
)

export default component.exports